// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"fc063c41","787":"f6e65957"}[chunkId] + ".chunk.js";
};